export function loanRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_LOAN_START":           
        case "FETCH_LOANS_START":                                 
        case "UPDATE_LOAN_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_LOAN_FULFILLED":           
        case "FETCH_LOANS_FULFILLED":                                 
        case "UPDATE_LOAN_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_LOAN_ERROR":
        case "FETCH_LOANS_ERROR":
        case "UPDATE_LOAN_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}